/*
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2022-03-01 15:14:47
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-03-09 14:26:40
 */
import router from "@/router"

// 判断是否为空 不为空返回数据 为空返回--
export const isNotNull = (data, str) => {
  if (isBlank(str)) {
    str = "--"
  }
  if (data == null || data === 'null' || data === '' || data === undefined || data === 'undefined' || data === 'unknown') {
    return str
  } else {
    return data
  }
}

// 判断是否为空 返回true/false
export const isBlank = (data) => {
  if (data == null || data === 'null' || data === '' || data === undefined || data === 'undefined' || data === 'unknown') {
    return true
  } else {
    return false
  }
}

// 返回上一页
export const backPage = () => {
  router.go(-1)
}

//判断两个日期之间相差几个月
export function getDistanceMonth (startTime, endTime) {
  startTime = new Date(startTime)
  endTime = new Date(endTime)
  var dateToMonth = 0
  var startDate = startTime.getDate() + startTime.getHours() / 24 + startTime.getMinutes() / 24 / 60
  var endDate = endTime.getDate() + endTime.getHours() / 24 + endTime.getMinutes() / 24 / 60
  console.log(startDate, endDate)
  if (endDate >= startDate) {
    dateToMonth = 0
  } else {
    dateToMonth = -1
  }
  let yearToMonth = (endTime.getYear() - startTime.getYear()) * 12
  let monthToMonth = endTime.getMonth() - startTime.getMonth()
  return yearToMonth + monthToMonth + dateToMonth
}
//邮箱校验
export function isEmail (s) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}
//手机号校验
export function isPhone (s) {
  return /^1(3|4|5|6|7|8)\d{9}$/.test(s)
}

//纳税人识别号
export function isTaxpayer (s) {
  return /^[A-Za-z0-9]*$/.test(s)
}

//字母+数字
export function istaxNo (s) {
  // return /(?!^\d+$)(?!^[a-zA-Z]+$)[0-9a-zA-Z]{1,18}/.test(s)
  if (/^\d+$/.test(s) || /^[a-z]+$/i.test(s)) {
    return false
  }
  return true
}


//  对象转 路径连接后面的拼接
export const urlEncode = (param, key, encode) => {
  if (param == null) return ''
  var paramStr = ''
  var t = typeof (param)
  if (t == 'string' || t == 'number' || t == 'boolean') {
    paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param)
  } else {
    for (var i in param) {
      var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
      paramStr += urlEncode(param[i], k, encode)
    }
  }
  return paramStr
}

export const toUifoxDownload = () => {
  window.open('https://uifox.com.cn/#/?type=contact')
}

// 页面跳转，并置顶
export const routerProxy = new Proxy(router.push, {
  apply (target, thisBinding, args) {
    setTimeout(() => {
      document.querySelector(".page").scrollTop = 0
    }, 0)
    return router.push(...args)
  }
})

/**
 * @description: try catch
 * @param {function} 需要执行逻辑的函数
 * @param {any} 执行函数的参数
 * @return: array: array[0]: 错误 array[1]: 结果
 */
export async function tryCatch() {
  const args = Array.from(arguments)
  const asyncFunc = args.shift()
  try {
    const res = await asyncFunc(...args)
    return [null, res]
  } catch (e) {
    return [e, null]
  }
}